<template>
    <div class="questions">

        <div class="question" v-for="(question, index) in questions" :key="question.id">
            <div class="question card">
                <div class="card-body">
                    <span class="card-title question-title">
                      {{question.question.question}}
                        <span v-if="question.question.required" style="color:#dc3545"> *</span>
                    </span>

                  <!-- Multiple choice -->
                    <div v-if="question.question.question_type_id === 1" class="multiple_choice">
                       <span v-for="(choice) in question.question.question_choices">
                           <input type="radio"
                                  :name="'multiple'+question.question.id"
                                  v-validate="question.question.required ? 'required' : ''"
                                  v-model="question.multiple_choice_id"
                                  :value="choice.id"> {{ choice.choice}}
                       </span>
                        <span v-if="submitted  && errors.has('multiple'+question.question.id)"
                              class="has_error">{{ t('evaluation_is_required') }}
                        </span>
                    </div>

                  <!-- Multiple answers -->
                  <div v-if="question.question.question_type_id === 5" class="multiple_choice">

                       <span v-for="(choice) in question.question.question_choices">
                           <input type="checkbox"
                                  :name="'multiple_options_'+question.question.id"
                                  v-validate="generateValidationRule(question)"
                                  v-model="question.multiple_answers_ids"
                                  :disabled="isMultipleChoiceOptionDisabled(question, choice)"
                                  :value="choice.id"> {{ choice.choice }}
                       </span>
                    <span v-if="submitted  && errors.has('multiple_options_'+question.question.id)"
                          class="has_error">{{ t('evaluation_is_required') }}
                        </span>
                  </div>

                  <!-- Yes No -->
                    <div v-if="question.question.question_type_id === 2" class="yes_no_choice">
                        <input type="radio"
                               v-validate="question.question.required ?'required' : ''"
                               :name="'yes_no'+question.question.id"
                               v-model="question.yes_no"
                               value="1"> {{ t('evalution_answer_yes') }}
                        <input type="radio"
                               :name="'yes_no'+question.question.id"
                               v-model="question.yes_no"
                               value="0"> {{ t('evalution_answer_no') }}
                        <div v-if="submitted  && errors.has('yes_no'+question.question.id)" class="has_error">{{ t('evaluation_is_required') }}
                        </div>
                    </div>


                  <!-- Rating -->
                    <div v-if="question.question.question_type_id === 3" class="rating">
                        <vue-stars
                                   style="font-size:21px"
                                   :active-color="'#ffdd00'"
                                   :inactive-color="'#DDDDDD'"
                                   :shadow-color="'#ffff00'"
                                   :hover-color="'#dddd00'"
                                   :max="evaluation.rating_max"
                                   v-model="question.rating"
                                   :name="'rating'+question.question.id"
                                   v-validate="question.question.required ? 'min_value:1' : ''">
                        </vue-stars>
                        <span v-if="submitted && errors.has('rating'+question.question.id)" class="has_error">{{ t('evaluation_is_required') }}</span>
                    </div>

                  <!-- Fretext -->
                    <span v-if="question.question.question_type_id === 4">
                        <textarea
                                :name="'freetext'+question.question.id"
                                class="form-control freetext"
                                v-model="question.freetext"
                                v-validate="question.question.required ?'required' : ''">
                        </textarea>
                        <span v-if="submitted  && errors.has('freetext'+question.question.id)"
                              class="has_error">{{ t('evaluation_is_required') }}</span>
                    </span>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        name: 'EvalQuestion',
        props: {
            questions: null,
            evaluation: null,
            submitted: false,

        },
      methods: {
        t : function(key){
          return this.$phrasePlugin.translate(key);
        },
        generateValidationRule(question) {
          let rule = question.question.required ? 'required' : '';
          // NB: limit_answers is the MAXIMUM number of choices (admin: "max_choices_for_question"),
          // not a required count. It's enforced by disabling further options once the cap is reached
          // (see isMultipleChoiceOptionDisabled). Do NOT add a `length:` rule here — vee-validate's
          // `length` requires an exact count, which wrongly forces the user to pick exactly the max.
          return rule;
        },
        isMultipleChoiceOptionDisabled(question, choice) {
          const hasAnswerLimit = question.question.limit_answers !== undefined && question.question.limit_answers !== null && question.question.limit_answers !== 0;
          const hasExceededAnswerLimit = hasAnswerLimit && question.multiple_answers_ids.length >= question.question.limit_answers;
          const choiceIsNotAlreadySelected = question.multiple_answers_ids.indexOf(choice.id) === -1;

          if (!question.question.limit_answers) {
            return false;
          }

          return hasExceededAnswerLimit && choiceIsNotAlreadySelected;
        }
      },
        watch: {
            errors: function (errorsNew) {
                console.log("errors watch", errorsNew);
                this.$emit("has-error");
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/components/evalquestion.scss";
</style>
